import { Component, Input, OnInit, inject } from '@angular/core';
import { Thumbnail } from '../../interfaces/Thumbnail';
import { FavouritesService } from '../../services/favourites.service';
import { ImgSrcSetDirective } from '../../directives/img-src-set.directive';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-thumbnail',
    templateUrl: './thumbnail.component.html',
    styleUrls: ['./thumbnail.component.scss'],
    imports: [RouterLink, ImgSrcSetDirective]
})
export class ThumbnailComponent implements OnInit {
  favouritesService = inject(FavouritesService);


  @Input() thumbnail: Thumbnail;
  @Input() index: number;
  loading = 'eager';

  ngOnInit(): void {
    this.favouritesService.load();
    // this.loading = this.index >= 4 ? 'lazy' : 'eager';
  }

  addToFavourites(): void {
    this.favouritesService.add(this.thumbnail.code);
  }

  removeFromFavourites(): void {
    this.favouritesService.remove(this.thumbnail.code);
  }
}
